export default __webpack_public_path__ + "static/media/stock1_fhd.40ace95e.jpg";